import { Enemy } from './Enemy.js'
import { PLAYER_DAMAGE } from '../game/CombatBalance.js'

export class Spider extends Enemy {
  constructor(game, x, y, id) {
    super(game, x, y, id, 'spider')
    
    this.maxHealth = 25
    this.health = 25
    this.damage = PLAYER_DAMAGE.LIGHT
    this.moveSpeed = 5.5 // Fast
    this.attackRange = 1.2
    this.attackCooldown = 0.8
    this.detectionRange = 20
  }
  
  dropLoot() {
    if (Math.random() < 0.35) {
      this.game.itemManager.spawnItem({
        type: 'item',
        id: 'spider_eye',
        name: 'Spider Eye',
        count: 1
      }, { x: this.x, y: this.y })
    }
    
    if (Math.random() < 0.5) {
      this.game.itemManager.spawnItem({
        type: 'item',
        id: 'string',
        name: 'String',
        count: Math.floor(Math.random() * 2) + 1
      }, { x: this.x, y: this.y })
    }
  }
}
